import createSetPayment from './setPayment';
import { paymentVar } from '../reactiveVariables';

const setPayment = createSetPayment(paymentVar);

export default setPayment;
